<template>
   <v-container fluid>
      <v-toolbar dense :color="$globalstore.settings_titleclass">
         <v-toolbar-title>
            <template v-if="$vuetify.breakpoint.mobile">
               <v-icon large class="mr-2" @click="goBack()">mdi-chevron-left</v-icon>
            </template>
            CCA Defaults
         </v-toolbar-title>
      </v-toolbar>
      <v-row class="pt-2">
         <v-col cols="8" md="4">
            <v-text-field
               label="Attendance Grace Period (mins)"
               v-model="attendance_grace_min"
               required
               :rules="attendance_grace_rule"
            >
            </v-text-field>
         </v-col>
         <v-col cols="8" md="4">
            <v-text-field
               label="Max CCA Per Student"
               v-model="maxcca_per_student"
               :rules="maxcca_rule"
            ></v-text-field>
         </v-col>
      </v-row>
      <v-row>
         <v-col cols="6" md="4">
            <label for="publishtime">
               Default Publish Time
            </label>
            <vue-timepicker
               class="ml-2"
               close-on-complete
               name="publishtime"
               :minute-interval="$globalstore.minute_interval"
               v-model="cca_publishtime"
               drop-direction="down"
               manual-input
               auto-scroll
            ></vue-timepicker>
         </v-col>

         <v-col cols="6" md="4">
            <label for="closingtime">Default Closing Time</label>
            <vue-timepicker
               class="ml-2"
               close-on-complete
               name="closingtime"
               :minute-interval="$globalstore.minute_interval"
               v-model="cca_closingtime"
               drop-direction="down"
               manual-input
               auto-scroll
            ></vue-timepicker>
         </v-col>
      </v-row>
      <v-row justify="space-around">
         <v-col cols="3" md="3">
            <v-btn class="primary" @click="saveSettings">Save</v-btn>
         </v-col>
      </v-row>

      <show-toast ref="toast"></show-toast>
      <confirm-dlg ref="confirm"></confirm-dlg>
   </v-container>
</template>

<script>
   import ConfirmDlg from "@/components/ConfirmDlg.vue";
   import ShowToast from "@/components/showToast.vue";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";

   export default {
      components: {
         ConfirmDlg,
         ShowToast,
         VueTimepicker,
      },

      data() {
         return {
            attendance_grace_min: 0,
            cca_publishtime: "",
            cca_closingtime: "",
            maxcca_per_student: "0",
            attendance_grace_rule: [
               (v) => !!v || "Grace period must be 0 or above.",
               (v) => !!/^[0-9]+$/.test(v) || "Grace period must be numeric.",
            ],
            maxcca_rule: [
               (v) => !!v || "Max CCA per student must be 0 or above.",
               (v) => !!/^[0-9]+$/.test(v) || "Max CCA per student must be numeric.",
            ],
         };
      },

      inject: ["ShowMessage"],

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         saveSettings() {
            if (
               this.attendance_grace_min != this.$globalstore.appsettings.attendance_grace_min ||
               this.cca_publishtime != this.$globalstore.appsettings.cca_publishtime ||
               this.cca_closingtime != this.$globalstore.appsettings.cca_closingtime ||
               this.maxcca_per_student != this.$globalstore.appsettings.max_cca_per_student
            ) {
               this.doSaveSettings();
            }
         },

         async doSaveSettings() {
            await this.$http({
               url: "/common/updateccasetting.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  attendancegrace: this.attendance_grace_min,
                  cca_publishtime: this.cca_publishtime,
                  cca_closingtime: this.cca_closingtime,
                  max_cca_per_student: this.maxcca_per_student,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadAppSettings();
                     this.$refs.toast.display({
                        message: response.data.message,
                        color: this.$globalstore.toast_successclass,
                     });
                  }
               }
            });
         },

         async reloadAppSettings() {
            await this.$http({
               url: "/common/getappsettings.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {section: "CCA"},
               method: "POST",
            }).then((response) => {
               console.log("Response", response);
               if (!response.data.error) {
                  this.$globalstore.appsettings = response.data.appsettings;
               } else {
                  this.ShowMessae({
                     title: "Fatal Error",
                     message: "Unable to read application settings.",
                     color: "red",
                  });
               }
            });
         },
      },

      mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            this.attendance_grace_min = this.$globalstore.appsettings.attendance_grace_minute;
            this.cca_publishtime = this.$globalstore.appsettings.cca_publish_time;
            this.cca_closingtime = this.$globalstore.appsettings.cca_closing_time;
            this.maxcca_per_student = this.$globalstore.appsettings.max_cca_per_student;
         }
      },
   };
</script>
